import { StyledFooter, SocialMediaCard } from "./style";
import facebook from "../../assets/images/socmed/facebook.svg";
import twitter from "../../assets/images/socmed/twitter.svg";
import telegram from "../../assets/images/socmed/telegram.svg";
import discord from "../../assets/images/socmed/discord.svg";

const Footer = () => {
  const SOCIAL_MEDIA = [
    {
      name: "facebook",
      icon: facebook,
      url: "https://www.facebook.com/monstainfinite",
    },
    {
      name: "twitter",
      icon: twitter,
      url: "https://twitter.com/monsta_infinite",
    },
    {
      name: "telegram",
      icon: telegram,
      url: "https://t.me/monstainfinite",
    },
    {
      name: "discord",
      icon: discord,
      url: "https://discord.gg/monsta-infinite-870195779451617380",
    },
  ];

  return (
    <StyledFooter>
      {SOCIAL_MEDIA.map((socmed) => {
        return (
          <a
            key={socmed.name}
            href={socmed.url}
            target="_blank"
            rel="noreferrer noopener"
          >
            <SocialMediaCard src={socmed.icon} preview={false} />
          </a>
        );
      })}
    </StyledFooter>
  );
};

export default Footer;
